import { render, staticRenderFns } from "./bet-button-group.vue?vue&type=template&id=60a3c6e4"
import script from "./bet-button-group.vue?vue&type=script&lang=js"
export * from "./bet-button-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a3c6e4')) {
      api.createRecord('60a3c6e4', component.options)
    } else {
      api.reload('60a3c6e4', component.options)
    }
    module.hot.accept("./bet-button-group.vue?vue&type=template&id=60a3c6e4", function () {
      api.rerender('60a3c6e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/lotto/bet-button-group.vue"
export default component.exports